import { Select, SelectChangeEvent } from '@shape-ds/components';
import { Controller, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormInputProps } from './FormInputProps';

export const FormSelect = <T extends FieldValues>({
  name,
  control,
  label,
  placeHolderText,
  selectOptionData,
  isRequired,
  disabled,
  readOnly,
  onChangeCallback,
  ...props
}: FormInputProps<T> & { onChangeCallback?: (newValue: string) => void }): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: isRequired ? t('components:inputs.required_field') : false }}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <div className={name.replace(/\./g, '-')}>
            <Select
              {...props}
              fullWidth
              required={isRequired}
              helperText={error ? error.message : undefined}
              data-testid={name}
              onChange={(event: SelectChangeEvent<unknown>) => {
                onChange(event);
                onChangeCallback?.(event.target.value as string);
              }}
              error={!!error}
              label={label}
              placeholder={placeHolderText}
              data={selectOptionData || []}
              value={value}
              name={name}
              disabled={disabled}
              readOnly={readOnly}
            />
          </div>
        );
      }}
    />
  );
};
